// Base URL for OAuth start + callback endpoints. Mirrors the legacy
// `g_env_domain` selector in web/scripts/common.js so that the CSRF
// cookie set on the initial POST and the cookie sent on the legacy
// callback page's exchange both target the SAME origin.
//
// Why this matters:
//   1. User clicks Continue with Google/Microsoft on /login.
//   2. We POST /auth/{provider}/login — server returns Set-Cookie
//      (agami_oauth_csrf=...; SameSite=none; Secure).
//   3. Browser stores the cookie at THE ORIGIN OF THE REQUEST URL.
//   4. Provider redirects to /callback.html (Microsoft) or
//      /google-callback (Google). Those legacy pages fetch the
//      callback endpoint DIRECT at Cloud Run (g_env_domain) to
//      bypass Netlify's 26s edge timeout for streaming endpoints.
//   5. For the cookie to be sent on step (4)'s fetch, it must have
//      been set at the same origin in step (3). So we use the same
//      direct-Cloud-Run URLs the legacy stack uses.
//
// Vite dev (localhost) keeps using the `/api` rewrite to the local
// uvicorn on :8000 — there's no cross-origin issue locally.
export function authBase(): string {
  if (typeof window === "undefined") return "/api";
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
    return "/api";
  }
  if (host === "ask.agami.ai") {
    return "https://data-agent-app-prod-89144766187.asia-south1.run.app";
  }
  if (host === "askstage.agami.ai") {
    return "https://data-agent-app-staging-89144766187.asia-south1.run.app";
  }
  // Direct-LB hosts serve the backend same-origin (no Netlify proxy in
  // front), so there is no /api prefix. Mirror the host list documented
  // in middleware/main.py near _MCP_LANDING_HOSTS — adding a host that
  // serves the bundled SPA without adding it here will 404 every
  // /api/auth/* call.
  if (
    host === "mcp.agami.ai" ||
    host === "mcpstage.agami.ai" ||
    host === "public.agami.ai" ||
    host === "publicstage.agami.ai" ||
    host === "demo.agami.ai"
  ) {
    return "";
  }
  // Default: assume Netlify proxy at /api (preserves current dev/test
  // behavior on agamistage.netlify.app etc.).
  return "/api";
}
